import BaseRequest from "./BaseRequest";
import { API_URL } from "../config/config";

const ResourcesRequest = () => (
    {
        getLogoById(idLogo, cancelToken = null) {
            return BaseRequest.axiosInst.get(`${API_URL}/resources/get-logo/${idLogo}`, {
                headers: BaseRequest.publicHeaders(),
                cancelToken
            });
        }
    }
)

export default ResourcesRequest();
